import { types } from 'mobx-state-tree';

/**
 * Order Event model.
 */
export const OrderEventModel = types.model('OrderEvent', {
  pickupLocationName: types.maybe(types.string),
  pickupTime: types.Date,
  pickupTimeEnd: types.Date,
  pickupTimeStart: types.Date,
  scheduleId: types.string,
});
